import styled from "styled-components";
import { Accordion } from "@gcs/design-system/react";

export const SectionPublicationsContainer = styled.section(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "40px",
  paddingTop: "40px",
  paddingBottom: "40px", 

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px", 
  }
}));

export const SectionPublicationsBlock = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const SectionPublicationsTitle = styled.h2(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "700",
  margin: "0",
  color: theme.color.brandPrimary.light,
  
  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  }
}));

export const SectionPublicationsDescription = styled.p(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "500",
  margin: 0,
  color: theme.color.neutral["02"],
}));

export const SectionPublicationsList = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "20px",

  [theme.breakpoint.xl()]: {
    flexDirection: "row",

    "div + div": {
      paddingLeft: "40px",
      borderLeft: "1px solid rgba(0, 0, 0, 0.1)",
    },
  },
}));

export const SectionPublicationsItem = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  flex: 1,
}));

export const SectionPublicationsItemTitle = styled.h3(({ theme }) => ({
  fontSize: "24px",
  fontWeight: "700",
}));

export const SectionPublicationsItemLink = styled.a(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",

  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "150%",
  color: theme.color.brandPrimary.light,

  [theme.breakpoint.lg()]: {
    fontSize: "18px",
  },

  span: {
    flex: 1,
  },

  svg: {
    width: "28px",
    height: "28px",
  },
}));

export const SectionPublicationsAccordionItem = styled(Accordion.Item)(() => ({
  display: "flex",
  flexDirection: "column",

  p: {
    fontSize: "18px",
  },
}));

export const SectionPublicationsAccordionItemList = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));
